import { Alert, Button, Modal, Table } from "antd"
import { formatDateTimeISO } from "../../../../utils/date";
import { useGetProductPlanUploadJobsQuery } from "../../../../api/usim/uploads/products/productPlansApi";
import { PlanUploadJobItem } from "../../../../api/usim/uploads/products/planUploadJobItem";

const columns = [
  {
    title: "Job ID",
    dataIndex: "Id",
    key: "Id",
  },
  {
    title: "Processed Started At",
    dataIndex: "UpdatedAt",
    key: "UpdatedAt",
    render: (v: string) => v ? formatDateTimeISO(v) : "-",
    sorter: (a: PlanUploadJobItem, b: PlanUploadJobItem) => a.UpdatedAt.localeCompare(b.UpdatedAt),
  },
  {
    title: "Processed Finished At",
    dataIndex: "ProcessedFinishedAt",
    key: "ProcessedFinishedAt",
    // render: (v: string) => v ? formatDateTimeISO(v) : "-"
    sorter: (a: PlanUploadJobItem, b: PlanUploadJobItem) => a.ProcessedFinishedAt.localeCompare(b.ProcessedFinishedAt),
  },
  {
    title: "Row Count (if successful)",
    dataIndex: "IngestedRows",
    key: "IngestedRows"
  },
  {
    title: "Error Count",
    dataIndex: "ErrorRows",
    key: "ErrorRows",
  },
  {
    title: "Status",
    dataIndex: "Status",
    key: "Status",
  },
  {
    title: "Action",
    key: "action",
    render: (_: any, obj: PlanUploadJobItem) => {
      function onClickViewErr() {
        Modal.confirm({
          content: obj.Errors!!.map(err => <li>{err}</li>),
          width: 800
        })
      }
      return (
        <Button
          disabled={obj.Errors == null}
          onClick={onClickViewErr}
        >
          View Errors
        </Button>
      )
    }
  }

]

export default function UploadJobTable() {
  const { data, error, isFetching, refetch } = useGetProductPlanUploadJobsQuery();

  const sData = data?.toSorted((a, b) =>
    b.UpdatedAt.localeCompare(a.UpdatedAt));

  return (
    <>
    <Button onClick={refetch} type="primary">Reload</Button>
    { error && <Alert type="error" message="Error loading data" /> }
    <Table
      loading={isFetching}
      dataSource={sData}
      pagination={{
        defaultPageSize: 10,
        pageSizeOptions: [10, 20, 50],
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: (total) => `Total ${total} records`,
      }}
      columns={columns}
    />
    </>
  )
}
